import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseHttpService } from '../../abstracts/base-http-service.abstract';
import { BaseResponse } from '../base.model';
import {
  DashboardTrendChartRequest,
  DashboardTrendChartResponse,
  GetTopNavSummaryResponse,
  LoginRequest,
  LoginResponse,
  RefreshUserTokenRequest,
  RefreshUserTokenResponse,
  UpdateUserSettingRequest,
  UpdateUserSettingResponse
} from './account.model';

const BASE_URL = '/api/v1/Account';

@Injectable({
  providedIn: 'root'
})
export class AccountApiService extends BaseHttpService {
  RefreshUserToken(data: RefreshUserTokenRequest): Observable<RefreshUserTokenResponse> {
    return this.httpPostSlient(`${BASE_URL}/RefreshToken`, data, false);
  }
  UserLogin(data: LoginRequest): Observable<LoginResponse> {
    return this.httpPost(`${BASE_URL}/Login`, data, false);
  }
  UserLogout(): Observable<BaseResponse> {
    return this.httpPostSlient(`${BASE_URL}/Logout`, {}, true);
  }
  UpdateUserSetting(data: UpdateUserSettingRequest): Observable<UpdateUserSettingResponse> {
    return this.httpPostSlient(`${BASE_URL}/UpdateUserSetting`, data, true);
  }
  GetTopNavSummary(): Observable<GetTopNavSummaryResponse> {
    return this.httpPost(`${BASE_URL}/GetTopNavSummary`, {}, true);
  }
  GetDashboardTrendChart(data: DashboardTrendChartRequest): Observable<DashboardTrendChartResponse> {
    return this.httpPost(`${BASE_URL}/GetDashboardTrendChart`, data, true);
  }
}
